import { render, staticRenderFns } from "./listDoctorInvoice.vue?vue&type=template&id=40d9ec81&scoped=true&"
import script from "./listDoctorInvoice.vue?vue&type=script&lang=js&"
export * from "./listDoctorInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d9ec81",
  null
  
)

export default component.exports